export default "__VITE_ASSET__6960c77f__"